import {
  useMutation,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import {
  ApiError,
  ContactSupportRequestDto,
  ContactSupportResponseDto,
} from "@mimber/schema"
import { supportKeys } from "../support.utils"

export const useContactSupport = (
  options?: UseMutationOptions<
    ContactSupportResponseDto,
    ApiError,
    ContactSupportRequestDto
  >
): UseMutationResult<
  ContactSupportResponseDto,
  ApiError,
  ContactSupportRequestDto
> => {
  guardAppUsage("mimber-organization", "useContactSupport")

  const { server } = useServerContext()

  return useMutation({
    ...options,
    mutationKey: supportKeys.contactSupport(),
    mutationFn: async (data: ContactSupportRequestDto) => {
      const response = await server.post<ContactSupportResponseDto>(
        "support/contact",
        data
      )
      return response.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
